<template>
  <div>
    <Head :title="$t('web.home.title')" />

    <div class="container mx-auto px-4 py-16">
      <div class="text-center">
        <h1 class="text-4xl font-bold mb-4">{{ $t('web.home.welcome') }}</h1>
        <p class="text-xl text-gray-600 mb-8">{{ $t('web.home.description') }}</p>
        <div class="space-x-4">
          <el-button type="primary" size="large">{{ $t('web.home.getStarted') }}</el-button>
          <el-button size="large">{{ $t('web.home.learnMore') }}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default { layout: Web }
</script>